tinymce.addI18n("ga", {
    "#": "",
    "Accessibility": "Inrochtaineacht",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Gn\xedomh",
    "Activity": "",
    "Address": "Seoladh",
    "Advanced": "Casta",
    "Align": "Ail\xednigh",
    "Align center": "Ail\xednigh sa l\xe1r",
    "Align left": "Ail\xednigh ar chl\xe9",
    "Align right": "Ail\xednigh ar dheis",
    "Alignment": "Ail\xedni\xfa",
    "Alignment {0}": "",
    "All": "",
    "Alternative description": "",
    "Alternative source": "Foinse mhalartach",
    "Alternative source URL": "",
    "Anchor": "",
    "Anchor...": "Ancaire...",
    "Anchors": "Ancair\xed",
    "Animals and Nature": "",
    "Arrows": "",
    "B": "G",
    "Background color": "Dath an ch\xfalra",
    "Background color {0}": "",
    "Black": "Dubh",
    "Block": "Bloc",
    "Block {0}": "",
    "Blockquote": "Athfhriotal",
    "Blocks": "Blocanna",
    "Blue": "",
    "Blue component": "",
    "Body": "Corp",
    "Bold": "Trom",
    "Border": "Iml\xedne",
    "Border color": "Dath na himl\xedne",
    "Border style": "",
    "Border width": "",
    "Bottom": "Bun",
    "Browse files": "",
    "Browse for an image": "Brabhs\xe1il le haghaidh \xedomh\xe1",
    "Browse links": "",
    "Bullet list": "Liosta Urchar",
    "Cancel": "Cealaigh",
    "Caption": "Fotheideal",
    "Cell": "Cill",
    "Cell padding": "Stu\xe1il ceall",
    "Cell properties": "Air\xedonna na cille",
    "Cell spacing": "Sp\xe1s\xe1il ceall",
    "Cell styles": "",
    "Cell type": "Cine\xe1l na cille",
    "Center": "Sa L\xe1r",
    "Characters": "",
    "Characters (no spaces)": "",
    "Circle": "Ciorcal",
    "Class": "Aicme",
    "Clear formatting": "Glan form\xe1idi\xfa",
    "Close": "D\xfan",
    "Code": "C\xf3d",
    "Code sample...": "Sampla c\xf3id",
    "Code view": "",
    "Color Picker": "",
    "Color swatch": "",
    "Cols": "Col\xfain",
    "Column": "Col\xfan",
    "Column clipboard actions": "",
    "Column group": "Gr\xfapa col\xfan",
    "Column header": "",
    "Constrain proportions": "Comhr\xe9ir faoi ghlas",
    "Copy": "C\xf3ipe\xe1il",
    "Copy column": "",
    "Copy row": "C\xf3ipe\xe1il an r\xf3",
    "Could not find the specified string.": "N\xedor aims\xedodh an teaghr\xe1n.",
    "Could not load emojis": "",
    "Count": "",
    "Currency": "",
    "Current window": "Fuinneog reatha",
    "Custom color": "Dath saincheaptha",
    "Custom...": "Saincheap...",
    "Cut": "Gearr",
    "Cut column": "",
    "Cut row": "Gearr an r\xf3",
    "Dark Blue": "",
    "Dark Gray": "",
    "Dark Green": "",
    "Dark Orange": "",
    "Dark Purple": "",
    "Dark Red": "",
    "Dark Turquoise": "",
    "Dark Yellow": "",
    "Dashed": "",
    "Date/time": "D\xe1ta/am",
    "Decrease indent": "Laghdaigh eang",
    "Default": "R\xe9amhshocr\xfa",
    "Delete accordion": "",
    "Delete column": "Scrios an col\xfan",
    "Delete row": "Scrios an r\xf3",
    "Delete table": "Scrios an t\xe1bla",
    "Dimensions": "Tois\xed",
    "Disc": "Diosca",
    "Div": "Deighilt",
    "Document": "",
    "Dotted": "",
    "Double": "",
    "Drop an image here": "Scaoil \xedomh\xe1 anseo",
    "Dropped file type is not supported": "",
    "Edit": "Eagar",
    "Embed": "Leabaigh",
    "Emojis": "",
    "Emojis...": "",
    "Error": "",
    "Error: Form submit field collision.": "",
    "Error: No form element found.": "",
    "Extended Latin": "",
    "Failed to initialize plugin: {0}": "",
    "Failed to load plugin url: {0}": "",
    "Failed to load plugin: {0} from url {1}": "",
    "Failed to upload image: {0}": "",
    "File": "Comhad",
    "Find": "Aimsigh",
    "Find (if searchreplace plugin activated)": "Aimsigh (m\xe1 t\xe1 an breise\xe1n cuardaigh ar si\xfal)",
    "Find and Replace": "Aimsigh agus Ionadaigh",
    "Find and replace...": "Aimsigh agus ionadaigh...",
    "Find in selection": "",
    "Find whole words only": "",
    "Flags": "",
    "Focus to contextual toolbar": "F\xf3cas sa bharra uirlis\xed comhth\xe9acs\xfail",
    "Focus to element path": "F\xf3cas sa chonair eiliminte",
    "Focus to menubar": "F\xf3cas sa bharra roghchl\xe1ir",
    "Focus to toolbar": "F\xf3cas sa bharra uirlis\xed",
    "Font": "Cl\xf3fhoireann",
    "Font size {0}": "",
    "Font sizes": "",
    "Font {0}": "",
    "Fonts": "Cl\xf3fhoirne",
    "Food and Drink": "",
    "Footer": "Bunt\xe1sc",
    "Format": "Form\xe1id",
    "Format {0}": "",
    "Formats": "Form\xe1id\xed",
    "Fullscreen": "L\xe1nsc\xe1ile\xe1n",
    "G": "U",
    "General": "Ginear\xe1lta",
    "Gray": "",
    "Green": "",
    "Green component": "",
    "Groove": "",
    "Handy Shortcuts": "Aicearra\xed \xdas\xe1ideacha",
    "Header": "Ceannt\xe1sc",
    "Header cell": "Cill cheannt\xe1isc",
    "Heading 1": "Ceannteideal 1",
    "Heading 2": "Ceannteideal 2",
    "Heading 3": "Ceannteideal 3",
    "Heading 4": "Ceannteideal 4",
    "Heading 5": "Ceannteideal 5",
    "Heading 6": "Ceannteideal 6",
    "Headings": "Ceannteidil",
    "Height": "Airde",
    "Help": "Cabhair",
    "Hex color code": "",
    "Hidden": "",
    "Horizontal align": "",
    "Horizontal line": "L\xedne chothrom\xe1nach",
    "Horizontal space": "Sp\xe1s cothrom\xe1nach",
    "ID": "",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "",
    "Image is decorative": "",
    "Image list": "Liosta \xedomh\xe1nna",
    "Image title": "",
    "Image...": "\xcdomh\xe1...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "M\xe9adaigh eang",
    "Inline": "Inl\xedne",
    "Insert": "Ions\xe1ig",
    "Insert Template": "",
    "Insert accordion": "",
    "Insert column after": "Ions\xe1igh col\xfan ar dheis",
    "Insert column before": "Ions\xe1igh col\xfan ar chl\xe9",
    "Insert date/time": "Cuir d\xe1ta/am isteach",
    "Insert image": "Cuir \xedomh\xe1 isteach",
    "Insert link (if link plugin activated)": "Cuir nasc isteach (m\xe1 t\xe1 an breise\xe1n naisc ar si\xfal)",
    "Insert row after": "Ions\xe1igh r\xf3 faoi",
    "Insert row before": "Ions\xe1igh r\xf3 os a chionn",
    "Insert table": "Ions\xe1igh t\xe1bla",
    "Insert template...": "Ions\xe1igh teimpl\xe9ad...",
    "Insert video": "Cuir f\xedse\xe1n isteach",
    "Insert/Edit code sample": "Cuir sampla c\xf3id isteach/in eagar",
    "Insert/edit image": "Cuir \xedomh\xe1 isteach/in eagar",
    "Insert/edit link": "Cuir nasc isteach/in eagar",
    "Insert/edit media": "Cuir me\xe1n isteach/in eagar",
    "Insert/edit video": "Cuir f\xedse\xe1n isteach/in eagar",
    "Inset": "",
    "Invalid hex color code: {0}": "",
    "Invalid input": "",
    "Italic": "Iod\xe1lach",
    "Justify": "Comhfhadaigh",
    "Keyboard Navigation": "",
    "Language": "Teanga",
    "Learn more...": "Tuilleadh eolais...",
    "Left": "Ar Chl\xe9",
    "Left to right": "Cl\xe9-go-deas",
    "Light Blue": "",
    "Light Gray": "",
    "Light Green": "",
    "Light Purple": "",
    "Light Red": "",
    "Light Yellow": "",
    "Line height": "",
    "Link list": "Liosta nascanna",
    "Link...": "Nasc...",
    "List Properties": "",
    "List properties...": "",
    "Loading emojis...": "",
    "Loading...": "",
    "Lower Alpha": "Alfa Beag",
    "Lower Greek": "Litir Bheag Ghr\xe9agach",
    "Lower Roman": "Litir Bheag R\xf3mh\xe1nach",
    "Match case": "C\xe1s-\xedogair",
    "Mathematical": "",
    "Media poster (Image URL)": "",
    "Media...": "Me\xe1n...",
    "Medium Blue": "",
    "Medium Gray": "",
    "Medium Purple": "",
    "Merge cells": "Cumaisc cealla",
    "Middle": "L\xe1r",
    "Midnight Blue": "",
    "More...": "Tuilleadh...",
    "Name": "Ainm",
    "Navy Blue": "",
    "New document": "C\xe1ip\xe9is nua",
    "New window": "Fuinneog nua",
    "Next": "Ar aghaidh",
    "No": "",
    "No alignment": "",
    "No color": "Gan dath",
    "Nonbreaking space": "Sp\xe1s neamhbhristeach",
    "None": "Dada",
    "Numbered list": "Liosta Uimhrithe",
    "OR": "N\xd3",
    "Objects": "",
    "Ok": "OK",
    "Open help dialog": "",
    "Open link": "Oscail nasc",
    "Open link in...": "Oscail nasc in...",
    "Open popup menu for split buttons": "",
    "Orange": "",
    "Outset": "",
    "Page break": "Briseadh leathanaigh",
    "Paragraph": "Alt",
    "Paste": "Greamaigh",
    "Paste as text": "Greamaigh mar th\xe9acs",
    "Paste column after": "",
    "Paste column before": "",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Sa m\xf3d gn\xe1th-th\xe9acs anois. Gream\xf3far \xe1bhar mar ghn\xe1th-th\xe9acs go dt\xed go m\xfachfaidh t\xfa an rogha seo.",
    "Paste or type a link": "Greamaigh n\xf3 cl\xf3scr\xedobh nasc",
    "Paste row after": "Greamaigh r\xf3 faoi",
    "Paste row before": "Greamaigh r\xf3 os a chionn",
    "Paste your embed code below:": "Greamaigh do ch\xf3d leabaithe th\xedos:",
    "People": "",
    "Plugins": "Breise\xe1in",
    "Plugins installed ({0}):": "Breise\xe1in shuite\xe1ilte ({0}):",
    "Powered by {0}": "\xc1 chumhacht\xfa ag {0}",
    "Pre": "R\xe9amh",
    "Preferences": "",
    "Preformatted": "R\xe9amhfhorm\xe1idithe",
    "Premium plugins:": "Scothbhreise\xe1in:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "",
    "Press {0} for help": "",
    "Preview": "R\xe9amhamharc",
    "Previous": "",
    "Print": "",
    "Print...": "Priont\xe1il...",
    "Purple": "",
    "Quotations": "",
    "R": "D",
    "Range 0 to 255": "",
    "Red": "",
    "Red component": "",
    "Redo": "Athdh\xe9an",
    "Remove": "",
    "Remove color": "",
    "Remove link": "Bain an nasc",
    "Replace": "Ionadaigh",
    "Replace all": "Ionadaigh uile",
    "Replace with": "Ionadaigh le",
    "Resize": "Athraigh m\xe9id",
    "Restore last draft": "Oscail an dr\xe9acht is d\xe9ana\xed",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "",
    "Rich Text Area. Press ALT-0 for help.": "",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Limist\xe9ar M\xe9ith-Th\xe9acs. Br\xfaigh ALT-F9 le haghaidh roghchl\xe1ir, ALT-F10 le haghaidh barra uirlis\xed, agus ALT-0 le c\xfanamh a fh\xe1il",
    "Ridge": "",
    "Right": "Ar Dheis",
    "Right to left": "Deas-go-cl\xe9",
    "Row": "R\xf3",
    "Row clipboard actions": "",
    "Row group": "Gr\xfapa r\xf3nna",
    "Row header": "",
    "Row properties": "Air\xedonna an r\xf3",
    "Row type": "Cine\xe1l an r\xf3",
    "Rows": "R\xf3nna",
    "Save": "S\xe1bh\xe1il",
    "Save (if save plugin activated)": "S\xe1bh\xe1il (m\xe1 t\xe1 an breise\xe1n s\xe1bh\xe1la ar si\xfal)",
    "Scope": "Sc\xf3ip",
    "Search": "",
    "Select all": "Roghnaigh uile",
    "Select...": "",
    "Selection": "",
    "Shortcut": "Aicearra",
    "Show blocks": "Taispe\xe1in blocanna",
    "Show caption": "",
    "Show invisible characters": "Taispe\xe1in carachtair dhofheicthe",
    "Size": "",
    "Solid": "",
    "Source": "Foinse",
    "Source code": "C\xf3d foinseach",
    "Special Character": "",
    "Special character...": "Carachtar speisialta,,,",
    "Split cell": "Roinn cill",
    "Square": "Cearn\xf3g",
    "Start list at number": "",
    "Strikethrough": "L\xedne tr\xedd",
    "Style": "St\xedl",
    "Subscript": "Foscript",
    "Superscript": "Forscript",
    "Switch to or from fullscreen mode": "",
    "Symbols": "Siombail\xed",
    "System Font": "Cl\xf3fhoireann C\xf3rais",
    "Table": "T\xe1bla",
    "Table caption": "",
    "Table properties": "Air\xedonna an t\xe1bla",
    "Table styles": "",
    "Template": "Teimpl\xe9ad",
    "Templates": "Teimpl\xe9id",
    "Text": "",
    "Text color": "Dath an t\xe9acs",
    "Text color {0}": "",
    "Text to display": "T\xe9acs le taispe\xe1int",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Is seoladh r\xedomhphoist \xe9 an URL a chuir t\xfa isteach. An bhfuil fonn ort an r\xe9im\xedr riachtanach mailto: a chur leis?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Is nasc seachtrach \xe9 an URL a chuir t\xfa isteach. An bhfuil fonn ort an r\xe9im\xedr riachtanach http:// a chur leis?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": " Is nasc seachtrach \xe9 an URL a chuir t\xfa isteach. An bhfuil fonn ort an r\xe9im\xedr riachtanach https:// a chur leis?",
    "Title": "Teideal",
    "To open the popup, press Shift+Enter": "",
    "Toggle accordion": "",
    "Tools": "Uirlis\xed",
    "Top": "Barr",
    "Travel and Places": "",
    "Turquoise": "",
    "Underline": "Fol\xedne",
    "Undo": "Cealaigh",
    "Upload": "Uasl\xf3d\xe1il",
    "Uploading image": "",
    "Upper Alpha": "Alfa M\xf3r",
    "Upper Roman": "Litir Mh\xf3r R\xf3mh\xe1nach",
    "Url": "URL",
    "User Defined": "",
    "Valid": "",
    "Version": "",
    "Vertical align": "",
    "Vertical space": "Sp\xe1s ingearach",
    "View": "Amharc",
    "Visual aids": "\xc1iseanna amhairc",
    "Warn": "",
    "White": "",
    "Width": "Leithead",
    "Word count": "",
    "Words": "",
    "Words: {0}": "Focail: {0}",
    "Yellow": "",
    "Yes": "",
    "You are using {0}": "T\xe1 t\xfa ag \xfas\xe1id {0}",
    "You have unsaved changes are you sure you want to navigate away?": "T\xe1 athruithe gan s\xe1bh\xe1il ann. An bhfuil t\xfa cinnte gur mhaith leat imeacht amach as seo?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "N\xed f\xe9idir le do bhrabhs\xe1la\xed teacht go d\xedreach ar an ngearrthaisce. Bain \xfas\xe1id as na haicearra\xed Ctrl+X/C/V. ",
    "alignment": "",
    "austral sign": "",
    "cedi sign": "",
    "colon sign": "",
    "cruzeiro sign": "",
    "currency sign": "",
    "dollar sign": "",
    "dong sign": "",
    "drachma sign": "",
    "euro-currency sign": "",
    "example": "",
    "formatting": "",
    "french franc sign": "",
    "german penny symbol": "",
    "guarani sign": "",
    "history": "",
    "hryvnia sign": "",
    "indentation": "",
    "indian rupee sign": "",
    "kip sign": "",
    "lira sign": "",
    "livre tournois sign": "",
    "manat sign": "",
    "mill sign": "",
    "naira sign": "",
    "new sheqel sign": "",
    "nordic mark sign": "",
    "peseta sign": "",
    "peso sign": "",
    "ruble sign": "",
    "rupee sign": "",
    "spesmilo sign": "",
    "styles": "",
    "tenge sign": "",
    "tugrik sign": "",
    "turkish lira sign": "",
    "won sign": "",
    "yen character": "",
    "yen/yuan character variant one": "",
    "yuan character": "",
    "yuan character, in hong kong and taiwan": "",
    "{0} characters": "",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} focal"
});